import { AnalyticsSdk } from '../../core/analytics-sdk'
import { OptInStateManager } from '../../core/global-state/opt-in-status'
import { SessionManager } from '../../core/global-state/session'
import { BrowserNetworkClient } from './browser-network-client'
import { BrowserStorage } from './browser-storage'
import { runtimeContextProvider as defaultRuntimeContextProvider } from './browser-runtime-info-provider'
import { InMemStorage } from './in-mem-storage'
import { JobQueue } from '../../core/job-queue'
import { RuntimeContextProvider } from '@mmt/events-schema'
import { Org } from '../../constants'

type CreateAnalyticsSdkOptions<T> = {
  runtimeContextProvider?: RuntimeContextProvider
  networkClient?: BrowserNetworkClient<T>
  org: Org
}

export function initAndGetAnalyticsSdk<T>(options: CreateAnalyticsSdkOptions<T>) {
  const storage = getStorage()
  const networkClient = options.networkClient || new BrowserNetworkClient<T>()
  const runtimeContextProvider = options.runtimeContextProvider
  const optInStateManager = new OptInStateManager(storage)
  const sessionManager = new SessionManager(storage)

  const config = {
    assertSchema: false,
    autoFlushIntervalInMs: 5000,
    maxBatchSize: 5,
  }
  const browserAnalyticsSdk = new AnalyticsSdk({
    optInStateManager,
    sessionManager,
    runtimeContextProvider,
    sdkRuntimeProvider: defaultRuntimeContextProvider,
    jobQueue: new JobQueue<T>(networkClient, storage, config),
    ...options,
  })

  // browserAnalyticsSdk.addValidator(commonsSchemaValidator)

  if (typeof window !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        browserAnalyticsSdk.onAppVisibilityChange('hidden')
      }
    })
  }
  return browserAnalyticsSdk
}

export function getStorage() {
  /**
   * This function checks for node env and safari's private mode env
   * */
  const isBrowserStorageAvailable = () => {
    try {
      if (typeof window?.localStorage !== 'undefined') {
        return true
      }
    } catch (e) {
      // ignore
    }
    return false
  }
  return isBrowserStorageAvailable() ? new BrowserStorage() : new InMemStorage()
}
